import { useMachine } from '@xstate/react';
import { useDIContainer } from '../hooks/useDIContainer';
import { createLoginMachine } from './login-machine';

let loginMachine: ReturnType<typeof createLoginMachine> | undefined;

const useLoginMachine = () => {
  const { authService, featureFlagService } = useDIContainer();

  if (!loginMachine) {
    loginMachine = createLoginMachine({
      authService,
      featureFlagService,
    });
  }

  return useMachine(loginMachine);
};

export { useLoginMachine };
